import styled from 'styled-components'

type Props = {
  backgroundColor: string
}

export const BotaoSVG = styled.button<Props>`
  margin-top: 7px;
  color: white;
  position: relative;

  .round-div {
    width: 20px;
    font-size: 12px;
    margin-top: 8px;
    margin-left: 15px;
    border-radius: 50%;
    position: absolute;
    background-color: ${({ backgroundColor }) =>
      backgroundColor ? backgroundColor : '#FF7100'};
  }

  svg {
    font-size: 25px;
  }
`
